import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Disable browser's native scroll restoration so React controls scroll position.
// This must run once before any navigation occurs.
if (typeof window !== 'undefined') {
  window.history.scrollRestoration = 'manual';
}

/**
 * Scrolls to the top of the page on every route change.
 * Render this once inside <Router> (ideally as the first child of <App>).
 */
const ScrollToTop: React.FC = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

export default ScrollToTop;
